"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var MaxPipe = (function () {
    function MaxPipe() {
    }
    MaxPipe.prototype.transform = function (value) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (!value)
            return value;
        var allowed = args[0];
        var received = value.length;
        if (received > allowed && allowed !== 0) {
            var toCut = allowed - received;
            return value.slice(0, toCut);
        }
        return value;
    };
    return MaxPipe;
}());
MaxPipe.decorators = [
    { type: core_1.Pipe, args: [{ name: 'max' },] },
];
/** @nocollapse */
MaxPipe.ctorParameters = function () { return []; };
exports.MaxPipe = MaxPipe;
//# sourceMappingURL=max.pipe.js.map


//////////////////
// WEBPACK FOOTER
// /deploy/www/v2/sa/app/emr-webapp/~/angular2-notifications/dist/src/simple-notifications/pipes/max.pipe.js
// module id = ../../../../angular2-notifications/dist/src/simple-notifications/pipes/max.pipe.js
// module chunks = 5